export const LANGUAGE_CHANGED = "language_changed";
export const LANGUAGE_TYPE_CHANGED = "language_type_changed";

export const SNACKBAR_CHANGED = "snackbar_Cahnged";

export const LOADING_DIALOG_CHANGED = "loading_dialog_changed";
